const isNumeric = (seg) => /^\d+$/.test(seg);

const getValueAfterMarker = (segments, marker) => {
  const idx = segments.indexOf(marker);
  const candidate = idx !== -1 ? segments[idx + 1] : "";
  return candidate && isNumeric(candidate) ? candidate : "";
};

const getNextNumericAfterIndex = (segments, startIdx) => {
  const candidate =
    startIdx !== -1 && startIdx + 1 < segments.length ? segments[startIdx + 1] : "";
  return candidate && isNumeric(candidate) ? candidate : "";
};

const parseSafaricomHierarchyDate = (pathSegments) => {
  if (!Array.isArray(pathSegments))
    return { year: "", month: "", day: "", label: null };

  const remainingSegments = pathSegments.slice(1);

  const yearRaw = remainingSegments.find((seg) => /^\d{4}$/.test(seg)) || "";

  let monthRaw = getValueAfterMarker(remainingSegments, "months");
  let dayRaw = getValueAfterMarker(remainingSegments, "days");

  const yearIdx = yearRaw ? remainingSegments.indexOf(yearRaw) : -1;
  if (!monthRaw) {
    monthRaw = getNextNumericAfterIndex(remainingSegments, yearIdx);
  }

  const monthIdx = monthRaw
    ? remainingSegments.indexOf(monthRaw, Math.max(yearIdx + 1, 0))
    : -1;
  if (!dayRaw && monthIdx !== -1) {
    dayRaw = getNextNumericAfterIndex(remainingSegments, monthIdx);
  }

  const paddedMonth = monthRaw ? String(monthRaw || "").padStart(2, "0") : "";
  const paddedDay = dayRaw ? String(dayRaw || "").padStart(2, "0") : "";

  const isoCandidate =
    yearRaw && paddedMonth && paddedDay
      ? `${yearRaw}-${paddedMonth}-${paddedDay}`
      : null;
  const candidateDate = isoCandidate ? new Date(isoCandidate) : null;
  const validLabel =
    isoCandidate &&
    candidateDate &&
    !Number.isNaN(candidateDate.getTime()) &&
    candidateDate.toISOString().slice(0, 10) === isoCandidate
      ? isoCandidate
      : null;

  return {
    year: yearRaw,
    month: validLabel ? paddedMonth : "",
    day: validLabel ? paddedDay : "",
    label: validLabel,
  };
};

const toIsoDate = (date) => date.toISOString().slice(0, 10);

const buildDateRange = (startDate, endDate, maxDays = 31) => {
  if (!startDate || !endDate) return [];
  const start = new Date(startDate);
  const end = new Date(endDate);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return [];

  const from = start <= end ? start : end;
  const to = start <= end ? end : start;
  const range = [];
  const cursor = new Date(from);

  while (cursor <= to && range.length < maxDays) {
    range.push(toIsoDate(cursor));
    cursor.setDate(cursor.getDate() + 1);
  }

  return range;
};

const clampDateToToday = (dateIso, todayIso = new Date().toISOString().slice(0, 10)) => {
  if (!dateIso) return "";
  const candidate = String(dateIso).slice(0, 10);
  return candidate > todayIso ? todayIso : candidate;
};

export {
  buildDateRange,
  clampDateToToday,
  getNextNumericAfterIndex,
  getValueAfterMarker,
  isNumeric,
  parseSafaricomHierarchyDate,
};
